import { render, staticRenderFns } from "./IndexMjjy.vue?vue&type=template&id=2bf5a00f&scoped=true&"
import script from "./IndexMjjy.vue?vue&type=script&lang=js&"
export * from "./IndexMjjy.vue?vue&type=script&lang=js&"
import style0 from "./IndexMjjy.vue?vue&type=style&index=0&id=2bf5a00f&scoped=true&lang=css&"
import style1 from "./IndexMjjy.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5a00f",
  null
  
)

export default component.exports